/* global axios */
import ApiClient from '../ApiClient';

class AilabTools extends ApiClient {
  constructor() {
    super('ailab/assistants/tools', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }
}

export default new AilabTools();
